export const CANDLES_SET_ERROR = "CANDLES::SET::ERROR"
export const CANDLES_SET_DATA = "CANDLES::SET::DATA"
export const CANDLES_UPDATE_DATA = "CANDLES::UPDATE::DATA"
